module.exports = __webpack_public_path__ + "static/media/README.1c27cfa5.md";